import React, { useEffect, useState, useRef } from "react";
import { Accordion } from "react-bootstrap";
import "./TauriAccordionAttachments.css";
import TauriLoader2 from "../../../TauriLoader2/TauriLoader2";
import TauriImage from "../../../TauriImage/TauriImage";
import TauriDocuments from "../../../TauriDocuments/TauriDocuments";
import { addRecord, deleteRecord, getAll, getNextId, getRecordById, updateRecord } from "../../../../localDB";
import { FileStatus, statusMapping } from "../../../../visualizations/visualizations";
import appURL from '../../../../appURL.json';
import OpalAlertModal from "../../../OpalAlertModal/OpalAlertModal";

const TauriAccordionAttachments = ({ section, id }) => {
    const [item, setItems] = useState([]);
    const [loading, setIsLoading] = useState();
    const [session, setSession] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [sessionAction, setSessionAction] = useState(null);

    const fileInputRef = useRef(null);

    const handleUploadFile = () => {
        const status = session?.Status;
        if (![statusMapping.pending, statusMapping.missed, statusMapping.inprogress].includes(status)) return;
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const nextID = await getNextId("file");
            const extension = file.name.split('.').pop();
            const fileName = file.name.replace(`.${extension}`, '');

            const newFile = {
                ID: nextID,
                FileType: 1,
                FileName: fileName,
                Extension: `.${extension}`,
                SearchTags: '',
                Status: 0,
                StoragePath: `/files/uploads/${file.name}`,
                AccessUrl: `https://example.com/files/uploads/${file.name}`,
                UploadBy: 1,
                UploadedDate: new Date().toISOString(),
                ApprovedBy: null,
                ApprovedDate: null,
                SyncStatus: 1
            };

            await addRecord('file', newFile);
            await fetchData();

        } catch (error) {
            console.error('Error saving file to localDB:', error);
        }
    };

    // 🔹 Moved download logic here so each file passes itself


    useEffect(() => {
        const fetchInitialData = async () => {
            setIsLoading(true);
            try {
                await fetchData();
            } catch (error) {
                console.error("Error during initial data fetch:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchInitialData();
    }, [id]);

    useEffect(() => {
        const handleRefresh = () => {
            fetchData();
        };
        window.addEventListener("refreshSession", handleRefresh);
        return () => {
            window.removeEventListener("refreshSession", handleRefresh);
        };
    }, [id]);

    const fetchData = async () => {
        try {
            // const usr_g = localStorage.getItem("usr_g");
            const rawFiles = await getAll("file");
            // const files = rawFiles.filter(a => a.UserType === Number(usr_g));
            const sess = await getRecordById("session", id);
            setItems(rawFiles);
            setSession(sess);
        } catch (error) {
            console.log(error);
        }
    };

    const handleDelete = async (fileId) => {
        const status = session?.Status;
        if (![statusMapping.pending, statusMapping.missed, statusMapping.inprogress].includes(status)) return;
        await deleteRecord("file", fileId);
        await fetchData();
    };

    const handleClick = async (file) => {
        // if (file.Status !== FileStatus.downloaded) {
        //     await handleDownloadClick(file);
        //     return;
        // }

        if (file.Status === FileStatus.downloaded && file?.BlobData && file.SizeClassification === "small") {
            const url = URL.createObjectURL(file.BlobData);
            window.open(url, "_blank", "noopener,noreferrer");

            // Clean up after some time
            setTimeout(() => URL.revokeObjectURL(url), 10000);
        } else if (file.SizeClassification === "large") {
            setSessionAction({
                title: "Message",
                bodyText: "Open the file from your Downloads folder",
                onConfirm: () => setShowMessage(false),
                confirmText: "OK"
            });
            setShowMessage(true);
            return;
        }
    };

    return (
        <div className="tauri-accordion-attachments mb-2 d-none d-md-block">
            <Accordion defaultActiveKey="0" alwaysOpen>
                <Accordion.Item eventKey="0">
                    <Accordion.Header className="p-0 mb-2">
                        <div className="header-container">
                            <div className="header-left">
                                <TauriImage localImage={section?.icon} className="tat-icon me-2" alt="icon" />
                                <span className="header-title">{section?.header.toUpperCase()}</span>
                            </div>
                            <span className="item-count">{item?.length} items</span>
                        </div>
                    </Accordion.Header>

                    <Accordion.Body className="py-0 px-0">
                        {loading ? (
                            <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                        ) : (
                            <div className="container-fluid">
                                <div className="row">
                                    {item?.map((file, index) => (
                                        <div key={index} className="col-6 col-lg-4 d-flex align-items-center py-2 px-0">
                                            <TauriDocuments
                                                doc={file}
                                                handleDeleteClick={() => handleDelete(file?.ID)}
                                                handleClick={() => handleClick(file)}
                                            />
                                        </div>
                                    ))}
                                    {/* <div className="col-6 col-lg-4 d-flex align-items-center py-2 px-0 upload-item" onClick={handleUploadFile}>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex align-items-center gap-2">
                                                <TauriImage localImage="/Images/mdi--upload.svg" className="img-icon" alt="icon"/>
                                                <div className="d-flex flex-column">
                                                    <div className="document-title">Upload File</div>
                                                </div>
                                            </div>
                                        </div>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}
                                        />
                                    </div> */}
                                </div>
                            </div>

                        )}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {sessionAction && (
                <OpalAlertModal
                    show={showMessage}
                    onHide={() => setShowMessage(false)}
                    title={sessionAction.title}
                    bodyText={sessionAction.bodyText}
                    onConfirm={sessionAction.onConfirm}
                    confirmButtonText={sessionAction.confirmText}
                    cancelButtonText=""
                    modalType="message"
                />
            )}
        </div>
    );
};

export default TauriAccordionAttachments;
